import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import style from "./AddSection.module.scss";
import { Loader } from "../../common/Loaders/Loader";
import { useTranslation } from "react-i18next";
const customStyles = {
  overlay: {
    zIndex: 1000,
    background: "rgba(34,34,34, 0.3)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 1167,
    width: "765px",
    borderRadius: 12,
    padding: "40px",
  },
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  name?: string;
  onSubmit: (name: string) => Promise<string>;
  isEdit: boolean;
  setNotice: React.Dispatch<React.SetStateAction<{ isShow: boolean; message: string; type: string }>>;
};

const AddSectionModal = ({ isOpen, onClose, name, onSubmit, isEdit, setNotice }: Props) => {
  const [sectionName, setSectionName] = useState<string>(name || "");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const { t } = useTranslation();

  const handleSubmit = async () => {
    if (!sectionName.trim()) {
      setError(t("AddSectionModal.プロジェクト名を入力してください。"));
      return;
    }
    setError("");
    setLoading(true);
    const errorMsg = await onSubmit(sectionName.trim());
    setLoading(false);
    onClose();
    if (errorMsg) {
      setNotice({ isShow: true, message: errorMsg, type: "error" });
    }
  };

  useEffect(() => {
    setSectionName(name || "");
    setError("");
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={t("AddSectionModal.新しいセクションを追加")}
      style={customStyles}
    >
      <div className={style.modalContent} data-testid="add-section-modal">
        <div className={style.headerContainer}>
          <div className={style.modalTitle}>
            {isEdit ? t("AddSectionModal.プロジェクトの編集") : t("AddSectionModal.プロジェクトの新規作成")}
          </div>
          <div className={style.modalDescription}>
            {isEdit
              ? t("AddSectionModal.プロジェクト名を編集します。")
              : t("AddSectionModal.新たにプロジェクトを作成します。プロジェクト名を入力してください。")}
          </div>
        </div>
        <div className={style.inputContainer}>
          <div className={style.inputLabel}>{t("AddSectionModal.プロジェクト名")}</div>
          <div className={`${style.input} ${error ? style.errorInput : ""}`}>
            <input
              type="text"
              value={sectionName}
              onChange={(e) => setSectionName(e.target.value)}
              data-testid="project-name-input"
            />
          </div>
          {error && <div className={style.errorMessage}>{error}</div>}
        </div>
        <div className={style.buttonContainer}>
          <button className="btn btn-secondary" onClick={onClose} data-testid="cancel-button">
            {t("AddSectionModal.キャンセル")}
          </button>
          <button
            className="btn btn-info d-flex align-items-center justify-content-center"
            onClick={handleSubmit}
            data-testid="submit-button"
          >
            {loading ? <Loader /> : isEdit ? t("AddSectionModal.保存する") : t("AddSectionModal.新規作成")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddSectionModal;
